import { createContext } from 'react';
import type { AccordionContextProps } from './AccordionTypes';

export const AccordionContext = createContext<
  Pick<AccordionContextProps, 'size' | 'onToggleSection'>
>({ size: 's' });
